<template>
	<main class="linha">
		<div class="container">
			<div class="blocosDuvidas">
				<BlockDuvida v-for="categoria in categorias" :key="categoria.id" :titulo="categoria.nome" :duvidas="duvidas[categoria.slug]" :slug="categoria.slug" />
			</div>
		</div>
	</main>
</template>

<script>
import BlockDuvida from '@/components/duvidasBlock.vue';

export default {
	name: 'home',
	components: {
		BlockDuvida,
	},
	beforeCreate() {
		this.$store.dispatch('changeHome', true);
	},
	computed: {
		categorias() {
			return this.$store.getters.categorias;
		},
		duvidas() {
			return this.$store.getters.duvidas;
		},
		duvidasLoaded() {
			return this.$store.getters.duvidasLoaded;
		},
	},
};
</script>

<style lang="scss">
@import './../assets/sass/home';
</style>
